import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-why_us-type03',
  standalone: true,
  imports: [MatIconModule, NgClass],
  templateUrl: './why_us-type03.component.html',
  styleUrl: './why_us-type03.component.scss'
})
export class WhyUsType03Component implements OnInit {

  public view: any = {};

  constructor(private _tfmService: TFMService) { }

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
  
      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);
  
    });
    
  }

}
